export default __webpack_public_path__ + "static/media/header-tf-logo.24fc1bf5.png";